/**
 * Thrown in place of any legacy v1/v2 API call (via WSService/axios).
 *
 * The v1/v2 API is deprecated. We keep the service interfaces, queries and
 * mutations in place, but the underlying call functions no longer hit the
 * network — they throw NotMigrated instead. Anything that still surfaces this
 * error is a call site that must be migrated to the v3 API.
 */
export class NotMigrated extends Error {
  readonly method: string;
  readonly serviceRoot: string;
  readonly url: string;

  constructor(method: string, serviceRoot: string, url: string) {
    super(
      `NotMigrated: ${method} ${serviceRoot}${url} — this v1/v2 API call is deprecated and must be migrated to the v3 API.`
    );
    this.name = "NotMigrated";
    this.method = method;
    this.serviceRoot = serviceRoot;
    this.url = url;

    Object.setPrototypeOf(this, NotMigrated.prototype);
  }
}
